import React from 'react';

const DisasterResponse = () => {
    return (
        <div className="industry-section">
            <div className="industry-content">
                <h2>Natural Disaster Response</h2>
                <p>
                    When disasters strike, our rapid-response LiDAR services provide critical data for emergency management and recovery operations. Our technology enables quick assessment of damage to buildings, infrastructure, and natural landscapes after floods, hurricanes, earthquakes, and wildfires.
                </p>
                <p>
                    With precise before-and-after comparisons, emergency managers can prioritize resources, identify unsafe structures, plan evacuation routes, and accelerate recovery efforts with data-driven decisions.
                </p>
                <div className="industry-features">
                    <span className="feature-item">Flood Impact Assessment</span>
                    <span className="feature-item">Wildfire Damage Mapping</span>
                    <span className="feature-item">Landslide Risk Analysis</span>
                    <span className="feature-item">Structural Damage Inspection</span>
                    <span className="feature-item">Search and Rescue Planning</span>
                </div>
            </div>
            <div className="industry-image">
                <img src="/img/industries/disaster.png" alt="Disaster Response LiDAR Application" />
            </div>
        </div>
    );
};

export default DisasterResponse;
